// State variables
const section = document.querySelector(".join-team-section");
let viewfinder = null;
let particleCanvas = null;

// Initialize elements once DOM loads
window.addEventListener("DOMContentLoaded", () => {
  viewfinder = document.getElementById("viewfinder-portal");
  particleCanvas = document.getElementById("particle-canvas");
  
  initParticles();
  initViewfinder();
});

/* ==========================================================================
   1. 3D Tilt Interaction
   ========================================================================== */
function initViewfinder() {
  if (!viewfinder) return;

  // Track mouse coordinates for 3D Tilt Math
  viewfinder.addEventListener("mousemove", (e) => {
    const rect = viewfinder.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const dx = e.clientX - rect.left - centerX;
    const dy = e.clientY - rect.top - centerY;
    
    // Tilt sensitivity (maximum degrees)
    const maxTilt = 8;
    const tiltX = -(dy / centerY) * maxTilt;
    const tiltY = (dx / centerX) * maxTilt;

    // Apply smooth 3D rotation transform to the frame
    viewfinder.style.transform = `rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.02)`;
  });

  // Reset viewport tilt on mouse leave
  viewfinder.addEventListener("mouseleave", () => {
    viewfinder.style.transform = "rotateX(0deg) rotateY(0deg) scale(1)";
  });
}

/* ==========================================================================
   2. Interactive Gold Dust Particles Canvas
   ========================================================================== */
let particles = [];
let mouse = { x: null, y: null, radius: 150 };

function initParticles() {
  if (!particleCanvas) return;
  const ctx = particleCanvas.getContext("2d");
  
  function resizeCanvas() {
    particleCanvas.width = window.innerWidth;
    particleCanvas.height = window.innerHeight;
  }
  
  resizeCanvas();
  window.addEventListener("resize", resizeCanvas);

  // Track global mouse coordinates for repulsion
  window.addEventListener("mousemove", (e) => {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
  });

  window.addEventListener("mouseleave", () => {
    mouse.x = null;
    mouse.y = null;
  });

  class GoldParticle {
    constructor() {
      this.x = Math.random() * particleCanvas.width;
      this.y = Math.random() * particleCanvas.height;
      this.size = Math.random() * 2 + 0.5; // Small spark sizes
      this.baseX = this.x;
      this.baseY = this.y;
      this.speedY = Math.random() * 0.4 + 0.1; // slow vertical drift
      this.speedX = (Math.random() - 0.5) * 0.15;
      this.alpha = Math.random() * 0.5 + 0.2;
      this.pulseSpeed = Math.random() * 0.02 + 0.005;
      this.pulseDirection = 1;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(212, 175, 55, ${this.alpha})`;
      ctx.shadowBlur = this.size * 2;
      ctx.shadowColor = "#d4af37";
      ctx.fill();
    }

    update() {
      // 1. Particle vertical drift
      this.y -= this.speedY;
      this.x += this.speedX;

      // Loop particles if they drift off top
      if (this.y < 0) {
        this.y = particleCanvas.height;
        this.x = Math.random() * particleCanvas.width;
      }
      if (this.x < 0 || this.x > particleCanvas.width) {
        this.speedX = -this.speedX;
      }

      // 2. Pulse brightness
      this.alpha += this.pulseSpeed * this.pulseDirection;
      if (this.alpha > 0.8 || this.alpha < 0.15) {
        this.pulseDirection = -this.pulseDirection;
      }

      // 3. Mouse deflection logic
      if (mouse.x !== null && mouse.y !== null) {
        const dx = this.x - mouse.x;
        const dy = this.y - mouse.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < mouse.radius) {
          const force = (mouse.radius - distance) / mouse.radius;
          const forceX = (dx / distance) * force * 3;
          const forceY = (dy / distance) * force * 3;

          this.x += forceX;
          this.y += forceY;
        }
      }
    }
  }

  // Create particles
  particles = [];
  const numParticles = 65;
  for (let i = 0; i < numParticles; i++) {
    particles.push(new GoldParticle());
  }

  // Loop animation
  function animate() {
    ctx.clearRect(0, 0, particleCanvas.width, particleCanvas.height);
    
    // Clear shadow properties for standard runs
    ctx.shadowBlur = 0;
    
    for (let i = 0; i < particles.length; i++) {
      particles[i].update();
      particles[i].draw();
    }
    
    requestAnimationFrame(animate);
  }

  animate();
}
